import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getNaaRedirectUrl, setInnerContent } from '../lib/globalHelper';
import { QuestionAlt } from './svg-sets';
import Page from '../lib/page';
import l10n from '../lib/reactPPl10nHelper';
import { trackLink, trackPage } from '../lib/analytics-helper';
import UrlResources from '../home/constants/UrlResources';

class NaaAlert extends Component {
  // Get display Name. For JP market return lastName and all other markets return firstName.
  static getDisplayName() {
    const userProfile = Page.getUserProfile();
    if (typeof userProfile === 'object') {
      if (Page.getCountry().toLowerCase() === 'jp' && Object.hasOwnProperty.call(userProfile, 'lastName')) {
        return userProfile.lastName;
      }
      if (Object.hasOwnProperty.call(userProfile, 'firstName')) {
        return userProfile.firstName;
      }
      return '';
    }
    return '';
  }

  // On component update if display is true fire impression event.
  componentDidUpdate() {
    if (this.props.display) {
      trackPage({ id: this.getNaaAlertId(), link: 'naa-alert|shown', name: this.props.pathName });
    }
  }

  // Get corresponding FPTI is based on the path name.
  getNaaAlertId() {
    switch (this.props.pathName) {
      case 'contact-us':
        return 'NAAContactUs';
      case UrlResources.HOME:
        return 'NAAHomePage';
      case UrlResources.TOPIC:
        return 'NAATopicPage';
      case UrlResources.ARTICLE:
        return 'NAAArticlePage';
      case UrlResources.PAYPALGUIDE:
        return 'NAAIcfPage';
      case UrlResources.SEARCH:
        return 'NAASearchPage';

      default:
        return '';
    }
  }

  // Click here link handler
  clickHereHandler(e) {
    e.preventDefault();
    trackLink({ id: this.getNaaAlertId(), link: 'naa-alert|link|clicked', name: this.props.pathName });
    window.open(getNaaRedirectUrl(), '_self');
  }

  renderNeverActiveAccountAlert() {
    if (this.props.display) {
      return (
        <div id="naa-alert" className="alert-container sh-alert-container">
          <div className="sh-alert-container--icon">{QuestionAlt()}</div>
          <div className="sh-alert-container--content">
            <span // eslint-disable-line jsx-a11y/no-static-element-interactions
              onClick={(e) => this.clickHereHandler(e)}
              dangerouslySetInnerHTML={setInnerContent(
                l10n.getContent('smarthelp/home.home.alert.NAA.Message', {
                  Name: NaaAlert.getDisplayName(),
                  link: getNaaRedirectUrl(),
                }),
              )}
            />
          </div>
        </div>
      );
    }

    return <div />;
  }

  render() {
    return this.renderNeverActiveAccountAlert();
  }
}

// Get States from `popular` Reducer.
function mapStateToProps(states) {
  return {
    display: states.popular.isNaaExists,
  };
}

// NaaAlert Props Types.
NaaAlert.propTypes = {
  display: PropTypes.bool.isRequired,
  pathName: PropTypes.string.isRequired,
};

// NaaAlert default values.
NaaAlert.defaultProps = {
  display: false,
};

export default connect(mapStateToProps)(NaaAlert);
